import login from './login';
import dict from './dict';
import sampleManage from './sampleManage';
import setting from './setting';
import sampleApply from './sampleApply';
import shoppingCart from './shoppingCart';
import sample from './sample';
import outsideSampleManage from './outsideSampleManage';
import user from './user';
import leadApprovalConfig from './leadApprovalConfig'
import pdLibrary from './pdLibrary'
import wishList from './wishList'

export default {
  login,
  dict,
  sampleManage,
  setting,
  sampleApply,
  shoppingCart,
  sample,
  outsideSampleManage,
  user,
  leadApprovalConfig,
  pdLibrary,
  wishList
};
